{
  "version": 1,
  "asset_id": "7256f861-ce32-40d0-82b6-0175f3673199",
  "project_id": "a3729fa2-e85b-4f5b-84b2-0934e880c580",
  "url": "/__l5e/assets-v1/7256f861-ce32-40d0-82b6-0175f3673199/ss01-card-n2.webp",
  "r2_key": "a/v1/a3729fa2-e85b-4f5b-84b2-0934e880c580/7256f861-ce32-40d0-82b6-0175f3673199/ss01-card-n2.webp",
  "original_filename": "ss01-card-n2.webp",
  "size": 99618,
  "content_type": "image/webp",
  "created_at": "2026-09-12T16:22:31Z"
}
